// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__LL_Ko","pingpong":"styles_pingpong__itLZW","embedded":"styles_embedded__bOmUD","fade-out":"styles_fade-out__3cZFO","fade-in":"styles_fade-in__Ge2fl"};